
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.026 27H1V6.762A2.786 2.786 0 013.8 4h22.4A2.786 2.786 0 0129 6.762V27h-5.369v-4.141a1.383 1.383 0 00-.41-.978 1.422 1.422 0 00-.992-.4h-2.8a1.425 1.425 0 00-.992.4 1.386 1.386 0 00-.41.978V27zm.7-12.88a1.425 1.425 0 00-.992.4 1.385 1.385 0 00-.41.977v1.843a1.382 1.382 0 00.41.977 1.425 1.425 0 00.992.4h4.2a1.422 1.422 0 00.992-.4 1.378 1.378 0 00.41-.977V15.5a1.4 1.4 0 00-.41-.977 1.422 1.422 0 00-.992-.4zm-11.664 0a1.422 1.422 0 00-.992.4 1.382 1.382 0 00-.41.977v1.843a1.378 1.378 0 00.41.977 1.422 1.422 0 00.992.4h4.2a1.425 1.425 0 00.992-.4 1.382 1.382 0 00.41-.977V15.5a1.385 1.385 0 00-.41-.977 1.425 1.425 0 00-.992-.4zM18.73 6.762a1.425 1.425 0 00-.992.4 1.382 1.382 0 00-.41.977v1.847a1.385 1.385 0 00.41.977 1.425 1.425 0 00.992.4h4.2a1.421 1.421 0 00.992-.4 1.382 1.382 0 00.41-.977V8.137a1.39 1.39 0 00-.41-.971 1.422 1.422 0 00-.992-.4zm-11.664 0a1.422 1.422 0 00-.992.4 1.378 1.378 0 00-.41.977v1.847a1.382 1.382 0 00.41.977 1.422 1.422 0 00.992.4h4.2a1.425 1.425 0 00.992-.4 1.385 1.385 0 00.41-.977V8.137a1.352 1.352 0 00-.41-.971 1.425 1.425 0 00-.992-.4z","fill":"#222"}})])
          )
        }
      }
    